import * as React from 'react';
import { STORE_PRINT } from '../constants';
import { inject, observer } from 'mobx-react';
import { PrintStore } from '../stores';
import { DemandForm } from './PrintForms/DemandForm';
import { ContractOrderForm } from './PrintForms/ContractOrderForm';



@inject(STORE_PRINT)
@observer
export class PrintForm extends React.Component<any, any> {
    printStore = (this.props as any)[STORE_PRINT] as PrintStore;

    public render() {
        return this.printStore.formName == "Demand" ?
            <DemandForm data={this.printStore.data} />
            : this.printStore.formName == "ContractOrder" ?
                <ContractOrderForm data={this.printStore.data} /> : []
    }
}
